import React from 'react'

const LogoutMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_18588)"
      fillOpacity="0.1"
    />
    <g clipPath="url(#clip0_103_18588)">
      <path
        d="M18 12.6663H14.78V11.6089C14.7799 11.3453 14.7017 11.0875 14.5552 10.8683C14.4087 10.6491 14.2005 10.4783 13.9569 10.3774C13.7133 10.2765 13.4452 10.2501 13.1866 10.3015C12.928 10.3529 12.6905 10.4798 12.504 10.6663L8.58399 14.5856C8.20904 14.9606 7.99841 15.4693 7.99841 15.9996C7.99841 16.5299 8.20904 17.0385 8.58399 17.4136L12.504 21.3329C12.6905 21.5193 12.928 21.6463 13.1866 21.6977C13.4452 21.7491 13.7133 21.7227 13.9569 21.6218C14.2005 21.5209 14.4087 21.3501 14.5552 21.1309C14.7017 20.9116 14.7799 20.6539 14.78 20.3902V19.3329H18.6667C19.7272 19.334 20.744 19.7557 21.4939 20.5057C22.2438 21.2556 22.6656 22.2724 22.6667 23.3329C22.6667 23.5097 22.7369 23.6793 22.8619 23.8043C22.9869 23.9293 23.1565 23.9996 23.3333 23.9996C23.5101 23.9996 23.6797 23.9293 23.8047 23.8043C23.9297 23.6793 24 23.5097 24 23.3329V18.6663C23.9982 17.0755 23.3655 15.5504 22.2407 14.4256C21.1158 13.3007 19.5907 12.668 18 12.6663Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_103_18588"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_103_18588">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
)

export default LogoutMenu
